export default __webpack_public_path__ + "static/media/858.abb34bd6.png";